module.exports = __webpack_public_path__ + "static/media/event1.597fe734.png";